import { useAtom } from "jotai";
import React, { Fragment, useMemo } from "react";
import Lightbox from "react-image-lightbox";
import { lightboxAtom } from "../../../../db";
import "react-image-lightbox/style.css";
import { nanoid } from "nanoid";
import log from "cslog";

function QLightbox() {
    const [lb, setLB] = useAtom(lightboxAtom);

    const refreshKey = useMemo(() => nanoid(5), [lb]);

    let lightbox = null;
    if (lb.length) {
        lightbox = (
            <Lightbox
                // key={refreshKey}
                mainSrc={lb[0]}
                onCloseRequest={() => setLB([])}
                onImageLoad={() => {
                    window.dispatchEvent(new Event("resize"));
                }}
            />
        );
    }

    return lightbox;

    // if (lb.length > 0) {
    //     return <Fragment>{lightbox}</Fragment>;
    // }
    // return <></>;
}

export default QLightbox;
